import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=6155bce4&scoped=true"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoveryPassword.vue?vue&type=style&index=0&id=6155bce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6155bce4",
  null
  
)

export default component.exports